import { Injectable } from '@angular/core';
import { App, Platform, LoadingController, ToastController, Events } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import 'rxjs/add/operator/map';
//Providers
import { ConfigProvider } from '../providers/config-provider';
import { StorageProvider } from '../providers/storage-provider';
//Components
import { CustomToastComponent } from '../components/custom-toast/custom-toast';
import { CustomAlert } from '../components/custom-alert.component';
import { Observable, BehaviorSubject } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class UtilProvider {

    public loading: any;
    public connected: boolean = true;
    public searchTerm: string = "";
    public searchInFocus: boolean = false;
    public isSearchSelected: boolean = false
    private isDesktop = new BehaviorSubject(false);

    constructor(private app: App, private platform: Platform,
        public configProvider: ConfigProvider,
        public loadingCtrl: LoadingController,
        public toastCtrl: ToastController,
        public alert: CustomAlert,
        public events: Events,
        public storageProvider: StorageProvider,
        public toast: CustomToastComponent,
        public network: Network) {
        setTimeout(() => {
            this.connected = this.network.type !== 'none' && this.network.type !== '';
        }, 500)

    }

    isNullOrEmpty(string) {
        return string == null || string == '' || string == undefined;
    }

    isUndefined(obj) {
        return obj == undefined;
    }

    any(obj) {
        if (!this.isUndefined(obj))
            return obj.length > 0;

        return null;
    }

    checkImage(string, type, isBackground) {
        if (this.isUndefined(isBackground))
            isBackground = true;

        if (this.isNullOrEmpty(string) || this.isUndefined(string)) {
            switch (type.toUpperCase()) {
                case 'USER':
                    string = this.configProvider.IMAGE_DEFAULT;
                    break;
            };
        }

        return isBackground ? 'url(\'' + string + '\')' : string;
    }

    toBackground(url) {
        return 'url(\'' + url + '\')'
    }

    openPage(page) {
        this.app.getActiveNav().setRoot(page.component);
    }

    redirectTo(page) {
        this.app.getActiveNav().push(page.component);
    }

    createGuid(length) {
        var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');

        if (!length) {
            length = Math.floor(Math.random() * chars.length);
        }

        var str = '';
        for (var i = 0; i < length; i++) {
            str += chars[Math.floor(Math.random() * chars.length)];
        }

        return str;
    }

    prepareSearch(string) {
        return string.toLowerCase().trim()
            .replace(/(á|à|ã|â|ä)/g, 'a')
            .replace(/(é|è|ê|ë)/g, 'e')
            .replace(/(é|è|î|ï)/g, 'i')
            .replace(/(ó|ò|ô|õ|ö)/g, 'o')
            .replace(/(ú|ù|û|ü)/g, 'u')
            .replace(/(!|\?|%|'|"|:)/g, '');
    }

    replaceChar(string, oldChar, newChar) {
        var regex = new RegExp(oldChar, 'g');

        return string.replace(regex, newChar);
    }

    reloadPage() {
        this.events.publish('page:reload');
    }

    reloadHelp() {
        let self = this;
        self.alert.dismiss();
        if (!self.connected) {
            self.alert.showAlertWithCallback('Sem conexão com a internet', this.getNoConnectedMessage(), 'Atualizar', () => { self.reloadHelp() });
        }

        return self.connected;
    }

    checkConnection() {

        let self = this;
        //Mudar connected para true quando for testar na web. Porque não reconhece o network.type
        //let disconnectSub = this.network.onDisconnect().subscribe(() => {
        //    setTimeout(() => {
        //        self.connected = true;
        //        //self.connected = this.network.type !== 'none' && this.network.type !== '';

        //    }, 500);
        //    localStorage.removeItem('connected');

        //});

        //let connectSub = this.network.onConnect().subscribe(() => {
        //    setTimeout(() => {
        //        self.connected = true;
        //        //self.connected = this.network.type != 'none' && !this.isNullOrEmpty(this.network.type);

        //    }, 500);
        //    localStorage.setItem('connected', 'true');
        //});
    }

    public isConnected(showMessage: boolean): boolean {
        let self = this;
        //Mudar connected para true quando for testar na web. Porque não reconhece o network.type
        this.connected = true
        //this.connected = this.network.type != 'none' && !this.isNullOrEmpty(this.network.type);
        if (!this.connected && showMessage) {
            if (!this.isFirstAccess())
                this.alert.showConfirm('Sem conexão com a internet', this.getNoConnectedMessage(), 'Atualizar', 'Cancelar', () => { self.reloadPage() });
            else
                this.alert.showAlertWithCallback('Sem conexão com a internet', this.getNoConnectedMessage(), 'Atualizar', () => { self.reloadHelp() });
        }

        return this.connected;
    }

    getNoConnectedMessage() {
        let msg = this.isFirstAccess() ? 'É necessário estar conectado para iniciar o aplicativo. Verifique sua conexão e tente novamente.' :
            'Verifique sua conexão e tente atualizar ou continue utilizando o aplicativo offline.';
        return msg;
    }

    isFirstAccess() {
        return localStorage.getItem('firstAccess') === "undefined" ||
            localStorage.getItem('firstAccess') === 'true' ||
            localStorage.getItem('firstAccess') === null;
    }

    getPlatform(): string {
        if (this.platform.is('ios'))
            return 'ios';
        else if (this.platform.is('android'))
            return 'android';
        else if (this.platform.is('windows'))
            return 'windows'
    }

    isPhone() {
        return this.platform.width() < 768;
    }

    isIPhone(){
        this.platform.is('iphone');
    }

    isTablet() {
        return this.platform.width() >= 768 && this.platform.width() <= 1024;
    }

    isDesktopView(): Observable<boolean>{
        return this.isDesktop.asObservable().pipe(distinctUntilChanged());
    }

    onResize(size){
    
        if(size <= 1024){
            this.isDesktop.next(false);
        }
        else{
            this.isDesktop.next(true);
        }
    }

    loadingShow() {
        this.loading = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });

        this.loading.present();
    }

    loadingHide() {
        this.loading.dismiss();
    }

    getDay(day: string) {
        return day.substring(0, 2);
    }

    getMonth(day: string) {
        return this.convertMonth(day.split('/')[1]);
    }

    formatHour(hour: string) {
        if (hour) {
            hour = hour.substring(0, 1) === '0' ? hour.substring(1) : hour;
            return hour.replace(':', 'h');
        }

        return "";
    }

    formatHourInFull(hour: string) {

        if (hour) {
            hour = hour.substring(0, 1) === '0' ? hour.substring(1) : hour;

            let minutos = hour.split(':')[1];
            let plural = Number(hour.split(':')[0]) > 1 ? "s" : "";

            let hora = hour.substring(0, 1) === '0' ? minutos + ' minutos' : 
            minutos && minutos != "00" ? hour.replace(':', ' hora'+ plural +' e ') + ' minutos' : hour.split(':')[0] + ' hora' + plural;
            return hora;
        }

        return "";
    }

    presentToast(text) {
        let toast = this.toastCtrl.create({
            message: text,
            duration: 3000,
            position: 'top'
        });
        toast.present();
    }

    hexToRgbA(hex, alpha) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c = hex.substring(1).split('');
            if (c.length == 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c = '0x' + c.join('');
            return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') +
                ',' + alpha + ')';
        }
        throw new Error('Bad Hex');
    }

    lightenDarkenColor(col, amt) {

        var usePound = false;
        if (col) {
            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }

            var num = parseInt(col, 16);

            var r = (num >> 16) + amt;

            if (r > 255) r = 255;
            else if (r < 0) r = 0;

            var b = ((num >> 8) & 0x00FF) + amt;

            if (b > 255) b = 255;
            else if (b < 0) b = 0;

            var g = (num & 0x0000FF) + amt;

            if (g > 255) g = 255;
            else if (g < 0) g = 0;
        }

        return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
    }

    checkTimeToRefresh(lastRefreshDate: string) {
        if (!lastRefreshDate)
            return false;

        let diff = (+(new Date()) - +(new Date(lastRefreshDate)));
        let minutes = Math.floor(diff / 6e4);

        return minutes >= 60;
    }

    formatDate(date: Date) {
        let year = date.getFullYear();
        let month = ((date.getMonth() + 1).toString().length < 2 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1));
        let day = ((date.getDate()).toString().length < 2 ? '0' + date.getDate() : date.getDate());
        let hours = ((date.getHours()).toString().length < 2 ? '0' + date.getHours() : date.getHours());
        let minutes = ((date.getMinutes()).toString().length < 2 ? '0' + date.getMinutes() : date.getMinutes());
        let seconds = '00';

        return date.getFullYear() + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds;
    }

    formaRefreshDate(date: string) {
        if (!date)
            return '';

        let mydate = new Date(date);
        mydate.setHours(mydate.getHours() - 3);

        let newDate = mydate.toISOString().replace('T', '-').split('-');
        let hour = newDate[3];
        return newDate[2] + '/' + newDate[1] + '/' + newDate[0] + ' às ' + newDate[3].substring(0, 5);
    }


    convertMonth(month: string) {
        switch (month) {
            case '01':
                return 'JANEIRO';
            case '02':
                return 'FEVEREIRO';
            case '03':
                return 'MARÇO';
            case '04':
                return 'ABRIL';
            case '05':
                return 'MAIO';
            case '06':
                return 'JUNHO';
            case '07':
                return 'JULHO';
            case '08':
                return 'AGOSTO';
            case '09':
                return 'SETEMBRO';
            case '10':
                return 'OUTUBRO';
            case '11':
                return 'NOVEMBRO';
            case '12':
                return 'DEZEMBRO';

        }
    }

}



// WEBPACK FOOTER //
// ./src/providers/util-provider.ts